<template>
  <div class="ui mini modal" ref="modal">
    <!--Mismo caso-->
    <i class="close icon" @click="$emit('close')"></i>
    <div class="content">
      <div class="ui form" ref="form">
        <h3 class="ui dividing header fdinpro default-header-green">
          {{ $t("update store data") }}
        </h3>
        <div class="field">
          <label class="disabled">{{ store.setup.name }}</label>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form">{{ $t("country") }}</label>
          <div
            class="ui fluid multiple search selection dropdown"
            ref="country_dropdown"
          >
            <input type="hidden" name="country" />
            <i class="dropdown icon"></i>
            <div class="default text">{{ $t("select country") }}</div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field" v-show="false">
          <label class="pt-05 fdinpro label-form">{{
            $t("phone number")
          }}</label>
          <input
            type="text"
            name="phone_number"
            placeholder=""
            v-model="d.phone_number"
          />
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form">{{
            $t("commercial email")
          }}</label>
          <input
            type="text"
            name="commercial_email"
            placeholder=""
            v-model="d.commercial_email"
          />
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form">{{
            $t("manager email")
          }}</label>
          <input
            type="text"
            name="manager_email"
            placeholder=""
            v-model="d.manager_email"
          />
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form">Tipo</label>
          <div class="ui fluid search selection dropdown" ref="type_dropdown">
            <input type="hidden" name="type" />
            <i class="dropdown icon"></i>
            <div class="default text">{{ $t("select type") }}</div>
            <div class="menu"></div>
          </div>
        </div>
        <div
          class="ui fluid button modal-button-green"
          tabindex="0"
          @click="send"
        >
          {{ $t("send") }}
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
// import vueFilePond from "vue-filepond";
// import uuid from "uuid/v4";
// Import FilePond styles
// import "filepond/dist/filepond.min.css";
// import country from "@/country.json";
import { countries } from "@/country.js";

// const FilePond = vueFilePond();

export default {
  components: {
    // FilePond,
  },
  name: "",
  props: {},
  computed: {
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.form).form({
        fields: {
          country: ["empty"],
          // phone_number: ["empty"],
          commercial_email: ["empty", "email"],
          manager_email: ["empty", "email"],
          type: ["empty"],
        },
      });
    },
  },
  data() {
    return {
      d: {
        country: "",
        phone_number: "",
        commercial_email: "",
        manager_email: "",
        type: "",
      },
      store: { setup: {} },
    };
  },
  methods: {
    send() {
      let vm = this;
      let isFormValid = true;
      isFormValid = vm.form.form("validate form");
      if (isFormValid) {
        local_api(vm, "post", "/nworkforce_nvidia/do-update-store-data", {
          d: vm.d,
          s: vm.store.store_id,
        })
          .then(function(r) {
            vm.$emit("store_updated", r);
            window.jQuery(vm.$refs.modal).modal("hide");
          })
          .catch(function(err) {
            error_toast(err);
          });
      }
    },
    do_show() {
      let vm = this;
      window
        .jQuery(vm.$refs.modal)
        .modal("show")
        .modal({
          onHidden() {
            vm.d = {
              country: "",
              phone_number: "",
              commercial_email: "",
              manager_email: "",
              type: "",
            };
            window.jQuery(vm.$refs.country_dropdown).dropdown("clear");
            window.jQuery(vm.$refs.type_dropdown).dropdown("clear");
          },
        });
    },
    set_data(store) {
      let vm = this;
      vm.store = store;
      console.log("set store data", store);
      if (store.setup && store.setup.country) {
        vm.d.country = store.setup.country;
        let vls = store.setup.country.split(",");
        window.jQuery(vm.$refs.country_dropdown).dropdown("set selected", vls);
      }
      if (store.setup && store.setup.phone_number)
        vm.d.phone_number = store.setup.phone_number;
      if (store.setup && store.setup.commercial_email)
        vm.d.commercial_email = store.setup.commercial_email;
      if (store.setup && store.setup.manager_email)
        vm.d.manager_email = store.setup.manager_email;
      if (store.setup && store.setup.type) {
        vm.d.type = store.setup.type;
        window
          .jQuery(vm.$refs.type_dropdown)
          .dropdown("set selected", store.setup.type);
      }
    },
  },
  mounted() {
    let vm = this;
    //Type dropdown
    let typeVls = ["Reseller", "Retail", "OEM"].map((c) => {
      return { name: c, value: c };
    });
    window
      .jQuery(vm.$refs.type_dropdown)
      .dropdown("setup menu", { values: typeVls })
      .dropdown({
        onChange(value) {
          vm.d.type = value;
        },
      });

    // Country dropdown
    let vls = countries.map((c) => {
      return { name: c.country, value: c.abbreviation };
    });
    window
      .jQuery(vm.$refs.country_dropdown)
      .dropdown("setup menu", { values: vls })
      .dropdown({
        onChange(value) {
          vm.d.country = value;
        },
      });
  },
};
</script>

<style scoped>
.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}

/*  SIDE BAR BUTTONS    */
.pbundle {
  align-items: center !important;
}
.pbundle div button {
  border-radius: 2rem !important;
}
.pbundle div .cgray {
  font-weight: 700 !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
</style>
